import { Button } from '@frontdoor/ui/components/button';
import { cn } from '@frontdoor/ui/lib/utils';
import { Phone } from 'lucide-react';

import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_E164 } from '@/lib/constants.ts';

export type HeaderPatientInfo = {
  patientName: string;
  orderId: string;
};

type HeaderProps = {
  className?: string;
  patientInfo?: HeaderPatientInfo | null;
};

export function Header({ className, patientInfo }: HeaderProps) {
  return (
    <header
      className={cn(
        'flex items-center justify-between border-b border-sand-100/60 px-4 py-4 shadow-[0_1px_7.6px_0_rgba(153,150,142,0.1)] sm:px-10',
        className
      )}
    >
      <img src="/logo_large.png" className="h-6.5 w-auto" alt="Conduit Health logo" />
      {patientInfo ? (
        <div className="flex flex-col items-end">
          <span className="text-base font-medium md:text-lg">{patientInfo.patientName}</span>
          <span className="text-sm text-charcoal-800">{`Order #${patientInfo.orderId}`}</span>
        </div>
      ) : (
        <Button variant="outline" size="sm" asChild className="bg-transparent no-underline">
          <a href={`tel:${SUPPORT_PHONE_E164}`}>
            <Phone className="fill-main" />
            {SUPPORT_PHONE_DISPLAY}
          </a>
        </Button>
      )}
    </header>
  );
}
